import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormService } from 'src/app/shared/services/form.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-dependents-not-added',
  templateUrl: './dependents-not-added.component.html',
  styleUrls: ['./dependents-not-added.component.scss']
})
export class DependentsNotAddedComponent implements OnInit {
 
  constructor(private formService: FormService, private dialogRef: MatDialogRef<DependentsNotAddedComponent>) { }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  } 
  
  wantToMoveForward(moveForward: boolean){
    //close modal no matter the selection
    this.dialogRef.close({ moveForward });
  }
}
